import React, { useState } from 'react';
import { useWallet } from '../../context/WalletContext';
import { shortAddress } from '../../utils/format';
import { pickAvatar } from '../../utils/userAvatar';
import Modal from '../common/Modal';
import Button from '../common/Button';

export default function AccountChip() {
  const { account, disconnect } = useWallet();
  const [open, setOpen] = useState(false);
  if (!account) return null;
  const avatar = pickAvatar(account);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="net-dot"
        style={{ background: '#ffffff', paddingLeft: 4, cursor: 'pointer', border: '1px solid var(--stroke)' }}
      >
        <img src={avatar} alt="" style={{ width: 22, height: 22, borderRadius: 999 }} />
        <span style={{ color: 'var(--g-700)', fontWeight: 800 }}>{shortAddress(account)}</span>
      </button>
      <Modal open={open} onClose={() => setOpen(false)} title="Account" subtitle={account}>
        <Button variant="ghost" block onClick={() => { disconnect(); setOpen(false); }}>Disconnect</Button>
      </Modal>
    </>
  );
}
